/** Strapi people-role "HoSA Admin" — published id 3, documentId e74ijf0evowbg759vrc5twvc */
const HOSA_ADMIN_ROLE_IDS = new Set([
	3,
	'3',
	'e74ijf0evowbg759vrc5twvc',
]);

// Kept free of imports so middleware.js can share it with the site.
export function isHosaAdmin(user) {
	if (!user) return false;

	const roleIds = Array.isArray(user.peopleRoles) ? user.peopleRoles : [];
	if (roleIds.some((role) => HOSA_ADMIN_ROLE_IDS.has(role))) {
		return true;
	}

	const roleTitles = Array.isArray(user.userRoles) ? user.userRoles : [];
	return roleTitles.some(
		(title) => String(title).trim().toLowerCase() === 'hosa admin'
	);
}
